import {
    Button,
    Col,
    Form,
    InputNumber,
    Modal,
    Row,
    Select,
    Space,
    Table,
    TimePicker,
    Typography,
    message,
    Input,
    List,
    Tag,
    Divider
  } from "antd";
  import { opConfirmModal } from "../opConfirmModal";
  import dayjs from "dayjs";
  import React, { useState, useEffect, useMemo, useContext, useRef } from "react";
  import {
    getTherapiesAPI,
    getPractitionersAPI,
    physioCareAPI,
    updatePhysioCareAPI,
    deletePhysioCareAPI,
    getSessionsAPI,
    submitTherapyAPI,
    updateTherapyAPI,
    createSessionAPI,
    deleteTherapyAPI,
  } from "../../../../services/outpatient.services";
  import useQuery from "../../../../hooks/useQuery";
  import { getOpServices } from "../../../../services/op.service";
  import { UserContext } from "../../../../context/UserContext";
  import utc from "dayjs/plugin/utc";
  import {
  createTherapyApi,
} from "../../../../services/therapy.services";
import { PlusOutlined } from "@ant-design/icons";
import { releaseAntModalLock } from "../../../../helpers/releaseAntModalLock";
  dayjs.extend(utc);

  const TimeFormat = "h:mm a";

  const SessionTableOp = ({
    // serviceOptions = [],
    refreshTables,
    // admissionID,
    facilityID,
    practitioners: parentPractitioners = [],
    date,
    sessionNumber,
    createSession,
    setCreateSession,
    fetchSessions,
    sessionData,
    setSessions,
  }) => {
    const { userDetails } = useContext(UserContext);
    const params = useQuery();
    const admissionID = params?.aid;
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const [editData, setEditData] = useState(null);
    const [timeDone, setTimeDone] = useState(dayjs());
    const [therapies, setTherapies] = useState([]);
    const [practitioners, setPractitioners] = useState(parentPractitioners);
    const [serviceOptions, setServiceOptions] = useState([]);
    const [newTherapy, setNewTherapy] = useState("");
    const therapyInputRef = React.useRef(null);
    // Keep create modal open locally so we can unmount parent only in afterClose
    // (avoids stuck ant-modal-mask that blocks all clicks on mobile).
    const [createModalOpen, setCreateModalOpen] = useState(!!createSession);

    const selectedServiceType = Form.useWatch("service_type", form);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const hasShownNoPackageErrorRef = useRef(false);
    const getNoPackageToastKey = () =>
      admissionID ? `curengo:no-active-package:${admissionID}` : null;
    const hasShownNoPackageToast = () => {
      if (hasShownNoPackageErrorRef.current) return true;
      try {
        const k = getNoPackageToastKey();
        return !!(k && sessionStorage.getItem(k) === "1");
      } catch {
        return false;
      }
    };
    const markNoPackageToastShown = () => {
      hasShownNoPackageErrorRef.current = true;
      try {
        const k = getNoPackageToastKey();
        if (k) sessionStorage.setItem(k, "1");
      } catch {
      }
    };
useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth <= 768);
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

useEffect(() => {
  setCreateModalOpen(!!createSession);
}, [createSession]);

useEffect(() => {
  // If this instance is torn down while a modal was open, clear any stuck lock
  return () => {
    releaseAntModalLock();
  };
}, []);
    const fetchServices = async () => {
  try {
    const res = await getOpServices(admissionID);

    const services = Array.isArray(res?.data?.data) ? res.data.data : [];
    setServiceOptions([...services, { name: "Others", value: "other_service" }]);
  } catch (err) {
    setServiceOptions([{ name: "Others", value: "other_service" }]);
  }
};
    const handleAddNewTherapy = async () => {
  if (!newTherapy.trim()) return;

  try {
    const payload = { name: newTherapy };

    const res = await createTherapyApi(payload);

    const createdTherapy = res?.data;

    const newOption = {
      label: createdTherapy?.name || newTherapy,
      value: createdTherapy?.id || newTherapy,
    };

    setTherapies((prev) => [...prev, newOption]);
    form.setFieldValue("therapy_label", [
      ...(form.getFieldValue("therapy_label") || []),
      newOption.value,
    ]);

    setNewTherapy("");
    message.success("Therapy added successfully");
    setTimeout(() => therapyInputRef.current?.focus(), 0);
  } catch (err) {
    console.error(err);
    message.error("Failed to add therapy");
  }
};

    const options = serviceOptions
      .map((service) => {
        const name =
          service?.name ??
          service?.label ??
          service?.service_name ??
          service?.title ??
          service?.value ??
          service?.id;

        if (!name) return null;

        const isOthers = String(name).toLowerCase() === "others";
        const processed = Number(service?.processed_count ?? 0);
        const actual = Number(service?.actual_count ?? 0);

        return {
          label:
            !isOthers && actual
              ? `${name} (${processed}/${actual})`
              : String(name),
          // Keep "Others" value as "Others" because form logic checks that.
          value: isOthers ? "Others" : service?.value ?? service?.id ?? String(name),
          disabled: !isOthers && actual > 0 ? processed >= actual : false,
        };
      })
      .filter(Boolean);

    const fetchOptions = async () => {
      try {
        const therapyRes = await getTherapiesAPI();
        const therapyList = Array.isArray(therapyRes?.data)
          ? therapyRes.data
          : therapyRes?.data?.data || therapyRes?.data?.results || [];
        const therapyOptions = therapyList.map((t) => ({
          label: t.name || t.service_name || t.title || `${t.id || ""}`,
          value: t.id || t.name || t.service_name || `${t.id || ""}`,
        }));
        setTherapies(therapyOptions);

        if (!parentPractitioners || parentPractitioners.length === 0) {
          if (facilityID) {
            const pracRes = await getPractitionersAPI(facilityID);
            const pracList = Array.isArray(pracRes?.data)
              ? pracRes.data
              : pracRes?.data?.data || pracRes?.data?.results || [];
            const uniquePracData = pracList
              .filter(
                (user, index, self) =>
                  index === self.findIndex((u) => u.user_id === user.user_id)
              )
              .map((user) => ({
                label: `${user?.first_name || ""} ${
                  user?.last_name || ""
                }`.trim(),
                value: user?.user_id || user?.id,
              }));
            setPractitioners(uniquePracData);
          } else {
            setPractitioners([]);
          }
        }
      } catch (err) {
        console.error(err);
        message.error("Failed to fetch therapies or practitioners.");
      }
    };

    useEffect(() => {
      if (facilityID) fetchOptions();
    }, [facilityID]);

    useEffect(() => {
      if (admissionID) {
        fetchServices();
      }
    }, [admissionID]);

    const handleOk = async () => {
      try {
        const data = await form.validateFields();

        const selectedTherapies = Array.isArray(data.therapy_label)
          ? data.therapy_label
          : data.therapy_label
          ? [data.therapy_label]
          : [];

        if (!selectedTherapies.length) {
          message.error("Please select at least one therapy.");
          return;
        }

        const requests = data?.therapy_label?.map((therapy) => {
          const payload = {
            admission: admissionID,
            session: sessionData?.id ,
            // service_type:
            //   data.service_type === "Others"
            //     ? "other_service"
            //     : "package_service",
            // service_name:
            //   data.service_type === "Others"
            //     ? data.service_name
            //     : data.service_type,
            // session_date: date
            //   ? dayjs(date).format("YYYY-MM-DD")
            //   : dayjs().format("YYYY-MM-DD"),
            therapy: therapy,
            done_by: data.done_by || null,
            duration:
              Math.floor(Number(data.duration) / selectedTherapies.length) || 0,
            time_done: dayjs(timeDone).utc().format("YYYY-MM-DD HH:mm:ss"),
            // ? timeDone.format("YYYY-MM-DD HH:mm:ss")
            // : dayjs().format("YYYY-MM-DD HH:mm:ss"),
            comments: data.comments || "",
          };
          return editData
            ? updateTherapyAPI(editData, payload)
            : submitTherapyAPI(payload);
        });

        await Promise.all(requests);

        message.success("Session saved successfully!");
        setOpen(false);
        form.resetFields();
        setEditData(null);
        // if (refreshTables) refreshTables();
        fetchSessions();
      } catch (err) {
        console.error(err);
        message.error("Failed to save session.");
      }
    };

    const handleNewSession = async () => {
      try {
        const data = await form.validateFields();
        const selectedTherapies = Array.isArray(data.therapy_label)
          ? data.therapy_label
          : data.therapy_label
          ? [data.therapy_label]
          : [];

        if (!selectedTherapies.length) {
          message.error("Please select at least one therapy.");
          return;
        }

        const hasAnyPackageService = (serviceOptions || []).some(
          (s) =>
            String(s?.name ?? s?.label ?? s?.service_name ?? s?.value ?? "").toLowerCase() !==
            "others"
        );
        if (data.service_type !== "Others" && !hasAnyPackageService) {
          if (!hasShownNoPackageToast()) {
            message.error("No active package found");
            markNoPackageToastShown();
          }
          return;
        }

        const sessionPayload = {
          admission: admissionID,
          session: Number(sessionNumber),
          service_type:
            data.service_type === "Others" ? "other_service" : "package_service",
          service_name:
            data.service_type === "Others"
              ? data.service_name
              : data.service_type,
          session_date: date
            ? dayjs(date).format("YYYY-MM-DD")
            : dayjs().format("YYYY-MM-DD"),
          comments: data.comments || "",
          created_by: userDetails?.id,
        };

        const sessionRes = await createSessionAPI(sessionPayload);
        const sessionId = sessionRes?.data?.id ||  Number(sessionNumber);

        const requests = selectedTherapies.map((therapy) => {
          const therapyPayload = {
            admission: admissionID,
            session: sessionId,
            therapy,
            done_by: data.done_by || null,
            duration:
              Math.floor(Number(data.duration) / selectedTherapies.length) || 0,
            time_done: timeDone
              ? dayjs(timeDone).utc().format("YYYY-MM-DD HH:mm:ss")
              : dayjs().utc().format("YYYY-MM-DD HH:mm:ss"),
            comments: data.comments || "",
          };

          return submitTherapyAPI(therapyPayload);
        });

        await Promise.all(requests);

        message.success("Session saved successfully!");
        // Close modal first; unmount parent in afterClose to avoid stuck mask
        setCreateModalOpen(false);
        form.resetFields();
        setEditData(null);
        fetchSessions();
      } catch (err) {
        console.error(err);
        message.error("Failed to save session.");
      }
    };

    const handleDelete = async (id) => {
      try {
        await deleteTherapyAPI(id);
        message.success("Session deleted successfully!");
        fetchSessions();
        if (refreshTables) refreshTables();
      } catch (err) {
        console.error(err);
        message.error("Failed to delete session.");
      }
    };

    const columns = [
      { title: "S.No", render: (_, __, index) => index + 1 },
      {
        title: "Therapy",
        dataIndex: "therapy_name",
        key: "therapy_name",
        render: (therapy) => therapy || "-",
      },
      // {
      //   title: "Name",
      //   dataIndex: "service_name",
      //   render: (name) => name || "-",
      // },
      {
        title: "Done By",
        dataIndex: "done_by",
        key: "done_by",
        render: (done_by) =>
          practitioners.find((p) => p.value === done_by)?.label || done_by || "-",
      },
      {
        title: "Time Done",
        dataIndex: "time_done",
        key: "time_done",
        render: (time_done) =>
          time_done ? dayjs.utc(time_done).local().format(TimeFormat) : "-",

      },
      {
        title: "Duration",
        dataIndex: "duration",
        key: "duration",
        render: (duration) => duration || "-",
      },
      {
        title: "Comments",
        dataIndex: "comments",
        key: "comments",
        render: (comments) => comments || "-",
      },
      {
        title: "Actions",
        render: (_, record) => (
          <Space>
            <Button
              size="small"
              onClick={() => {
                setOpen(true);
                setEditData(record.id);
                const firstTherapy = record || {};
                form.setFieldsValue({
                  service_type: record.service_type,
                  therapy_label: [record.therapy],
                  done_by: firstTherapy.done_by,
                  session: record.session,
                  time_done: firstTherapy.time_done
                     ? dayjs.utc(firstTherapy.time_done).local()
                     : dayjs(),

                  duration: firstTherapy.duration,
                  comments: firstTherapy.comments,
                });
                setTimeDone(
                  firstTherapy.time_done
                    ? dayjs.utc(firstTherapy.time_done).local()
                    : dayjs()
                );

              }}
            >
              Edit
            </Button>
            <Button
              size="small"
              danger
              onClick={() =>
                opConfirmModal({
                  title: "Confirm Delete",
                  onOk: () => handleDelete(record.id),
                })
              }
            >
              Delete
            </Button>
          </Space>
        ),
      },
    ];

    const totalDuration = sessionData?.therapies?.reduce(
      (acc, cur) => acc + (cur?.duration || 0),
      0
    );

    return (
      <Row gutter={[0, 8]}>
        <Col span={16}>
          {/* <List>
            <List.Item>
              <Typography>Service: {sessionData?.service_name}</Typography>
            </List.Item>
          </List> */}
          
        </Col>
        <Col span={8} className="flex-end">
          <Button onClick={() => setOpen(true)}>Add Therapy</Button>
        </Col>

        {sessionData?.therapies?.length > 0 && (
          <Col span={24}>
            <Typography>Total Duration: {totalDuration} min(s)</Typography>
          </Col>
        )}

        <Col span={24}>
          <Table
            dataSource={sessionData?.therapies}
            columns={columns}
            pagination={false}
            size="small"
            scroll={{
              x: isMobile ? 700 : 1200,
              y: "40vh",
            }}
            rowKey="id"
          />

        </Col>

        <Modal
  title="Physio Therapy Details"
  open={open}
  destroyOnClose
  afterClose={() => {
    releaseAntModalLock();
  }}
  onOk={sessionData?.id ? handleOk : handleNewSession}
  onCancel={() => {
    setOpen(false);
    form.resetFields();
    setEditData(null);
  }}
  maskClosable={false}
  centered={isMobile}
  wrapClassName={isMobile ? "op-compact-modal-wrap" : undefined}
  getContainer={() => document.body}
  width={isMobile ? undefined : "50%"}
  bodyStyle={
    isMobile
      ? {
          maxHeight: "60vh",
          overflowY: "auto",
        }
      : undefined
  }
>

          <Form form={form} layout="vertical">
            {(!sessionData || !sessionData.therapies || sessionData.therapies.length === 0) && (
                <>
                  <Form.Item
                    label="Service Type"
                    name="service_type"
                    rules={[
                      { required: true, message: "Please select service type" },
                    ]}
                  >
                    <Select
                      showSearch
                      options={options}
                      onSelect={(value) =>
                        form.setFieldValue("service_type", value)
                      }
                      allowClear
                      placeholder="Select service type"
                      optionFilterProp="label"
                    />
                  </Form.Item>

                  {selectedServiceType === "Others" && (
                    <Form.Item
                      label="Service Name"
                      name="service_name"
                      rules={[
                        { required: true, message: "Please enter service name" },
                      ]}
                    >
                      <Input
                        placeholder="Enter service name"
                        style={{ width: "100%", minWidth: 0 }}
                        maxLength={250}
                        count={true}
                      />
                    </Form.Item>
                  )}
                </>
              )}
            <Form.Item
              label="Therapy"
              name="therapy_label"
              rules={[{ required: true, message: "Please select therapy" }]}
            >
              <Select
                showSearch
                mode="multiple"
                options={therapies}
                disabled={!!editData}
                allowClear
                placeholder="Select therapy"
                optionFilterProp="label"
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    <Divider style={{ margin: "8px 0" }} />
                    <Space style={{ padding: "0 8px 4px" }}>
                      <Input
                        placeholder="Add new therapy"
                        ref={therapyInputRef}
                        value={newTherapy}
                        onChange={(e) => setNewTherapy(e.target.value)}
                        onKeyDown={(e) => e.stopPropagation()}
                      />
                      <Button type="text" onClick={handleAddNewTherapy}icon={<PlusOutlined />}>
                        Add
                      </Button>
                    </Space>
                  </>
                )}
              />
            </Form.Item>


            <Form.Item
              label="Done By"
              name="done_by"
              rules={[
                { required: true, message: "Please select a practitioner" },
              ]}
            >
              <Select
                showSearch
                options={practitioners}
                allowClear
                // placeholder="Search to select"
                optionFilterProp="label"
              />
            </Form.Item>

            <Form.Item
              label="Duration (min)"
              name="duration"
              rules={[{ required: true, message: "Please enter duration" }]}
            >
              <InputNumber
                // placeholder="in min"
                style={{ width: 70 }}
                controls={false}
              />
            </Form.Item>

            <Form.Item label="Comments" name="comments">
              <Input.TextArea rows={4} style={{ width: "100%" }} />
            </Form.Item>

            <Form.Item label="Time Done">
              <TimePicker
                inputReadOnly
                value={timeDone}
                format={TimeFormat}
                onChange={setTimeDone}
              />
            </Form.Item>
          </Form>
        </Modal>

        <Modal
  title="Physio Session Details"
  open={createModalOpen}
  destroyOnClose
  afterClose={() => {
    releaseAntModalLock();
    // Unmount create-session instance only after mask is gone
    setCreateSession?.(false);
  }}
  onOk={handleNewSession}
  onCancel={() => {
    setCreateModalOpen(false);
    form.resetFields();
    setEditData(null);
  }}
  maskClosable={false}
  centered={isMobile}
  wrapClassName={isMobile ? "op-compact-modal-wrap" : undefined}
  getContainer={() => document.body}
  width={isMobile ? undefined : "50%"}
  bodyStyle={
    isMobile
      ? {
          maxHeight: "60vh",
          overflowY: "auto",
        }
      : undefined
  }
>

          <Form form={form} layout="vertical">
            {createSession && (
              <>
                <Form.Item
                  label="Service Type"
                  name="service_type"
                  rules={[
                    { required: true, message: "Please select service type" },
                  ]}
                >
                  <Select
                    showSearch
                    options={options}
                    onSelect={(value) =>
                      form.setFieldValue("service_type", value)
                    }
                    allowClear
                    placeholder="Select service type"
                    optionFilterProp="label"
                  />
                </Form.Item>

                {selectedServiceType === "Others" && (
                  <Form.Item
                    label="Service Name"
                    name="service_name"
                    rules={[
                      { required: true, message: "Please enter service name" },
                    ]}
                  >
                    <Input
                      placeholder="Enter service name"
                      style={{ width: "100%", minWidth: 0 }}
                      maxLength={250}
                    />
                  </Form.Item>
                )}
              </>
            )}
            <Form.Item
              label="Therapy"
              name="therapy_label"
              rules={[{ required: true, message: "Please select therapy" }]}
            >
              <Select
                showSearch
                mode="multiple"
                options={therapies}
                disabled={!!editData}
                allowClear
                placeholder="Select therapy"
                optionFilterProp="label"
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    <Divider style={{ margin: "8px 0" }} />
                    <Space style={{ padding: "0 8px 4px" }}>
                      <Input
                        placeholder="Add new therapy"
                        ref={therapyInputRef}
                        value={newTherapy}
                        onChange={(e) => setNewTherapy(e.target.value)}
                        onKeyDown={(e) => e.stopPropagation()}
                      />
                      <Button type="text" onClick={handleAddNewTherapy} icon={<PlusOutlined />}>
                        Add
                      </Button>
                    </Space>
                  </>
                )}
              />
            </Form.Item>



            <Form.Item
              label="Done By"
              name="done_by"
              rules={[
                { required: true, message: "Please select a practitioner" },
              ]}
            >
              <Select
                showSearch
                options={practitioners}
                allowClear
                // placeholder="Search to select"
                optionFilterProp="label"
              />
            </Form.Item>

            <Form.Item
              label="Duration (min)"
              name="duration"
              rules={[{ required: true, message: "Please enter duration" }]}
            >
              <InputNumber
                // placeholder="in min"
                style={{ width: 70 }}
                controls={false}
              />
            </Form.Item>

            <Form.Item label="Comments" name="comments">
              <Input.TextArea rows={4} style={{ width: "100%" }} />
            </Form.Item>

            <Form.Item label="Time Done">
              <TimePicker
                inputReadOnly
                value={timeDone}
                format={TimeFormat}
                onChange={setTimeDone}
              />
            </Form.Item>
          </Form>
        </Modal>
      </Row>
    );
  };

  export default SessionTableOp;